import { AddressTypes } from './address-schema'

export const formatAddress = (address: AddressTypes) => {
  return `${address.thoroughfare}${address.premise ? ' ' + address.premise : ''}, ${address.locality}, ${address.adminarea} ${address.postcode}`
}
